import "./InfoDropdownListItem.scss"

import { FC } from "react"

interface IInfoDropdownListItemButtonProps {
    onClick?(): void | Promise<void>
    disabled?: boolean
}

const InfoDropdownListItemButton: FC<React.PropsWithChildren<IInfoDropdownListItemButtonProps>> = ({
    onClick,
    disabled,
    children,
}) => {
    function handleClick(event: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
        event.preventDefault()
        event.stopPropagation()
        if (disabled) return
        onClick?.()
    }

    return (
        <button
            className="info-dropdown-list-item info-dropdown-list-item--button"
            onMouseDown={e => handleClick(e)}
            disabled={disabled}>
            {children}
        </button>
    )
}

export default InfoDropdownListItemButton
